import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTaskTimerStore } from '@/entities/task/model/stores/task-timer';
import { useActiveTimerTask } from '@/features/tasks/model/useActiveTimerTask';
import { formatHMS } from '@/shared/utils/helpers';

function RunningIcon() {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className="shrink-0"
    >
      <path d="M2 1.2L8.3 5 2 8.8V1.2Z" fill="#57B792" />
    </svg>
  );
}

/** Текущая выполняемая задача — плей-иконка, название и живой счётчик
 *  ТЕКУЩЕГО запуска таймера (не общее время по задаче — оно может тянуться
 *  днями, а именно «сколько тикает с последнего нажатия старт»). */
export function DesktopSidebarActiveTimer() {
  const navigate = useNavigate();
  const { hasTask, isRunning, title, taskId } = useActiveTimerTask();

  // Собственный тик раз в секунду, пока таймер идёт — useActiveTimerTask
  // сам по себе не перерисовывает компонент каждую секунду.
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!isRunning || !taskId) {
      return;
    }
    const id = window.setInterval(() => setTick((x) => x + 1), 1000);
    return () => window.clearInterval(id);
  }, [isRunning, taskId]);

  if (!hasTask || !isRunning || !taskId) {
    return null;
  }

  const elapsedMs = useTaskTimerStore
    .getState()
    .getCurrentSegmentElapsed(taskId);

  return (
    <button
      type="button"
      onClick={() => navigate(`/tasks-new/${taskId}`)}
      title={title}
      className="flex w-full items-center gap-[8px] rounded-[10px] bg-[#F6FBF9] px-[10px] py-[7px] text-left transition-colors hover:bg-[#EDF7F3]"
    >
      <RunningIcon />
      <span className="min-w-0 flex-1 truncate text-[12px] font-medium leading-[130%] text-[#313846]">
        {title}
      </span>
      <span className="shrink-0 text-[11px] font-normal tabular-nums text-[#57B792]">
        {formatHMS(Math.floor(elapsedMs / 1000))}
      </span>
    </button>
  );
}
